import * as actionTypes from './actionTypes';

export const setPrefillValuesPrimary = (payload) => ({
	type: actionTypes.preFillValuePrimary,
	payload,
});

export const setPrefillValuesSecondary = (payload) => ({
	type: actionTypes.preFillValueSecondary,
	payload,
});

export const onEmailChangeHandler = (payload) => ({
	type: actionTypes.onChangeValuesEmail,
	payload,
});

export const setPrefillValuesPhonePrimary = (payload) => ({
	type: actionTypes.preFillValuePhonePrimary,
	payload,
});

export const setPrefillValuesPhoneSecondary = (payload) => ({
	type: actionTypes.preFillValuePhoneSecondary,
	payload,
});

export const onPhoneChangeHandler = (payload) => ({
	type: actionTypes.onChangeValuesPhone,
	payload,
});

export const setPrefillValuesAddressPrimary = (payload) => ({
	type: actionTypes.preFillValueAddressPrimary,
	payload,
});

export const setPrefillValuesAddressSecondary = (payload) => ({
	type: actionTypes.preFillValueAddressSecondary,
	payload,
});

export const onAddressChangeHandler = (payload) => ({
	type: actionTypes.onChangeValuesAddress,
	payload,
});

export const handleResetFormAddress = (payload) => ({
	type: actionTypes.resetFormValuesAddress,
	payload,
});

export const handleResetFormPhone = (payload) => ({
	type: actionTypes.resetFormValuesPhone,
	payload,
});

export const handleResetFormEmail = (payload) => ({
	type: actionTypes.resetFormValuesEmail,
	payload,
});

export const setPrefillValuesInfoPrimary = (payload) => ({
	type: actionTypes.preFillValueInfoPrimary,
	payload,
});

export const setPrefillValuesInfoSecondary = (payload) => ({
	type: actionTypes.preFillValueInfoSecondary,
	payload,
});

export const handleInfoChange = (payload) => ({
	type: actionTypes.inputInfo,
	payload,
});

export const handleResetFormInfo = (payload) => ({
	type: actionTypes.resetFormValuesInfo,
	payload,
});

export const handleResetFormRelatedContributor = (payload) => ({
	type: actionTypes.resetFormValuesRelatedContributor,
	payload,
});

export const handleRadioChangePrimary = (payload) => ({
	type: actionTypes.radioChangePrimary,
	payload,
});

export const handleRadioChangeSecondary = (payload) => ({
	type: actionTypes.radioChangeSecondary,
	payload,
});

export const reset = (payload) => ({
	type: actionTypes.resetVariable,
	payload,
});

export const disableButton = (payload) => ({
	type: actionTypes.addAdvisorButtonDisable,
	payload,
});

export const setPrimaryInfo = (payload) => ({
	type: actionTypes.storePrimaryInfo,
	payload,
});

export const getZipCode = (payload) => ({
	type: actionTypes.fetchZipCodeData,
	payload,
});

export const relatedContributorInfo = (payload) => ({
	type: actionTypes.fetchRCData,
	payload,
});
export const fieldValues = (payload) => ({
	type: actionTypes.storeFeildValues,
	payload,
});
export const relatedContributorPrimary = (payload) => ({
	type: actionTypes.relContributorPrimary,
	payload,
});

export const relatedContributorSecondary = (payload) => ({
	type: actionTypes.relContributorSecondary,
	payload,
});

export const addSuccessorCount = (payload) => ({
	type: actionTypes.incrementDecrementCount,
	payload,
});

export const handleInputChange = (payload) => ({
	type: actionTypes.inputChange,
	payload,
});

export const handleError = (payload) => ({
	type: actionTypes.handleError,
	payload,
});

export const setPercentage = (payload) => ({
	type: actionTypes.storePercentage,
	payload,
});

export const setLegacyValues = (payload) => ({
	type: actionTypes.storeLegacyValues,
	payload,
});

export const setSuccessorValues = (payload) => ({
	type: actionTypes.storeSuccessorValues,
	payload,
});

export const setSuccessorTab = (payload) => ({
	type: actionTypes.successorTab,
	payload,
});

export const addSuccessor = (payload) => ({
	type: actionTypes.addSuccessorValues,
	payload,
});

export const updateActivePageStepName = (payload) => ({
	type: actionTypes.updateActivePageStepName,
	payload,
});

export const resetLegacy = (payload) => ({
	type: actionTypes.resetLegacy,
	payload,
});

export const showRemainingPercentage = (payload) => ({
	type: actionTypes.showRemainingPercentage,
	payload,
});

export const getAccordionStatus = (payload) => ({
	type: actionTypes.stepTwoAccordionToggleStatus,
	payload,
});

export const toggleStepTwoUpdateButton = (payload) => ({
	type: actionTypes.stepTwoUpdateButton,
	payload,
});

export const removeValues = (payload) => ({
	type: actionTypes.removeValues,
	payload,
});

export const showMainPercentage = (payload) => ({
	type: actionTypes.mainPercentage,
	payload,
});

export const shouldClose = (payload) => ({
	type: actionTypes.shouldCloseAccordion,
	payload,
});

export const isSecondaryAdvisor = (payload) => ({
	type: actionTypes.secondaryAdvisor,
	payload,
});

export const shouldShowMore = (payload) => ({
	type: actionTypes.showMore,
	payload,
});

export const step1Edit = (payload) => ({
	type: actionTypes.stepOneEdit,
	payload,
});

export const step2Edit = (payload) => ({
	type: actionTypes.stepTwoEdit,
	payload,
});

export const jsonfinal = (payload) => ({
	type: actionTypes.storeFinalJson,
	payload,
});

export const jsonTemp = (payload) => ({
	type: actionTypes.storeTempJson,
	payload,
});

export const jsonTempForStep1 = (payload) => ({
	type: actionTypes.storeTempForStepOne,
	payload,
});

export const validateSubmit = (payload) => ({
	type: actionTypes.validateFinal,
	payload,
});

export const setEstimateInitialContribution = (payload) => ({
	type: actionTypes.initialContribution,
	payload,
});

export const emptyZip = (payload) => ({
	type: actionTypes.emptyZipStateCity,
	payload,
});

export const closeModalAPIFail = (payload) => ({
	type: actionTypes.closeFormModal,
	payload,
});

export const updateReducerAdvisor = (payload) => ({
	type: actionTypes.storeChnagesStepOneReducer,
	payload,
});

export const dummyFunctionForTheTimeBeing = (payload) => ({
	type: actionTypes.storeOaaEdit,
	payload,
});

export const validationHandler = (payload) => ({
	type: actionTypes.validationCheckStatus,
	payload,
});

export const resetFormData = (payload) => ({
	type: actionTypes.resetData,
	payload,
});

export const updateErrorState = (payload) => ({
	type: actionTypes.updateErrState,
	payload,
});

export const updateAccordionStatus = (payload) => ({
	type: actionTypes.updateAccordStatus,
	payload,
});

export const updateAccordionState = (payload) => ({
	type: actionTypes.updateAccordState,
	payload,
});

export const clearReducerForOpenAdditionalAccount = (payload) => ({
	type: actionTypes.resetData,
	payload,
});

export const setCityFieldEdit = (payload) => ({
	type: actionTypes.setCityField,
	payload,
});

export const fetchAlertForOAA = () => ({
	type: actionTypes.fetchAlertContentsOaa,
});

export const showOaaSubmitLoader = () => ({
	type: actionTypes.oaaSubmitLoader
})
